import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface MenuStateInterface {
  activeItem: string,
  selectedItem: string,
  hoveredItem: string,
  submenuOnScreen: boolean,
  notificationOverlayOpen: boolean,
  searchOverlayOpen: boolean,
  menuOverlayOpen: boolean,
  menuPopoverOpen: boolean,
  menuPopoverTarget: string
}

const initialState: MenuStateInterface = {
  activeItem: 'statistics/dashboard',
  selectedItem: 'statistics/dashboard',
  hoveredItem: '',
  submenuOnScreen: false,
  notificationOverlayOpen: false,
  searchOverlayOpen: false,
  menuOverlayOpen: false,
  menuPopoverOpen: false,
  menuPopoverTarget: null,
}

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setActiveMenuItem(state, action: PayloadAction<string>) {
      const activeItem = action.payload
      return { ...state, activeItem, selectedItem: activeItem, hoveredItem: initialState.hoveredItem }
    },
    setTemporaryActiveItem(state, action: PayloadAction<string>) {
      const { selectedItem } = state
      const activeItem = action.payload
      const [menuItem] = selectedItem.split('/')

      // if selectedItem === activeItem return selectedItem because it contains active submenu item
      if (menuItem === activeItem) {
        return { ...state, activeItem: selectedItem }
      }

      return { ...state, activeItem }
    },
    resetTemporaryActiveMenuItem(state) {
      return { ...state, activeItem: state.selectedItem, hoveredItem: initialState.hoveredItem }
    },
    setHoveredMenuItem(state, action: PayloadAction<string>) {
      return { ...state, hoveredItem: action.payload }
    },
    setSubmenuState(state, action: PayloadAction<boolean>) {
      return { ...state, submenuOnScreen: action.payload }
    },
    toggleNotificationOverlay(state, action: PayloadAction<boolean>) {
      return { ...state, notificationOverlayOpen: action.payload, searchOverlayOpen: false, menuOverlayOpen: false }
    },
    toggleSearchOverlay(state, action: PayloadAction<boolean>) {
      return { ...state, searchOverlayOpen: action.payload, notificationOverlayOpen: false, menuOverlayOpen: false }
    },
    toggleMenuOverlay(state, action: PayloadAction<boolean>) {
      return { ...state, menuOverlayOpen: action.payload, notificationOverlayOpen: false, searchOverlayOpen: false }
    },
    openMenu(state, action: PayloadAction<string>) {
      return { ...state, menuPopoverTarget: action.payload, menuPopoverOpen: true }
    },
    setMenuTarget(state, action: PayloadAction<string>) {
      return { ...state, menuPopoverTarget: action.payload }
    },
    closeMenu(state) {
      return { ...state, menuPopoverTarget: null, menuPopoverOpen: false }
    },
  },
})

export const {
  setActiveMenuItem,
  setTemporaryActiveItem,
  resetTemporaryActiveMenuItem,
  setHoveredMenuItem,
  setSubmenuState,
  toggleNotificationOverlay,
  toggleSearchOverlay,
  toggleMenuOverlay,
  openMenu,
  setMenuTarget,
  closeMenu,
} = menuSlice.actions
export default menuSlice.reducer
